import { Injectable } 		        from '@angular/core';
import { Router, CanActivate }    from '@angular/router';
import { StsPortalStatus }        from '../models/sts-portal-status';
import { StsPortalStatusService } from './sts-portal-status.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// Redirects user to login if not authenticated in portal
//
@Injectable()
export class StsRouteRequiresAuth implements CanActivate {

  constructor(private stsPortalStatusService: StsPortalStatusService, private router: Router) {
  }

  canActivate() {
    return this.stsPortalStatusService.getPortalStatus().pipe(
      map((portalStatus: StsPortalStatus) => {
        if (portalStatus &&
            !portalStatus.isLoggedIn &&
            !portalStatus.isInRecoveryMode) {
          console.log('User *not* logged in, redirecting to login page!');
          this.router.navigateByUrl('/account/signin');
          return false;
        }
        return true;
     }),
     catchError((err) => {
        console.log('Unable to verify portal authentication status, redirecting to login page!');
        this.router.navigateByUrl('/account/signin');
        return of(false);
      })
    );
  }

}
